import { ButtonGroup, Button, Flex, useMediaQuery } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

export interface Properties {
  selectedYear?: string;
  color?: string;
  bg?: string;
  timeGranularity: string;
  fontColor?: string;
  onChangeSummeryMode: (value: string) => void;
  isDisabled?: boolean;
}

// Purple-accented variant of TabsFilter, split out so revamp-only styling
// changes land here instead of the shared file every non-revamp Plan page
// (PlanPageOutputOptimization, PlanPageDetailsOPZ, Dashboard-v2, ...) uses.
const RevampTabsFilter = ({
  timeGranularity,
  onChangeSummeryMode,
  selectedYear,
  bg,
  fontColor,
  isDisabled = false,
}: Properties) => {
  const [displayLevels, setDisplayLevels] = useState(timeGranularity);
  const [isMobile] = useMediaQuery('(max-width: 768px)');
  useEffect(() => {
    setDisplayLevels(timeGranularity);
  }, [timeGranularity]);

  const handleChange = (value: string) => {
    if (isDisabled) return;
    setDisplayLevels(value);
    onChangeSummeryMode(value);
  };

  useEffect(() => {
    if (displayLevels === 'Y' && selectedYear !== 'all') {
      setDisplayLevels('M');
      onChangeSummeryMode('M');
    }
  }, [selectedYear]);

  return (
    <Flex gap='6px'>
      <ButtonGroup
        isAttached
        variant='none'
        size={isMobile ? 'xs' : 'xs'}
        display='flex'
        isDisabled={isDisabled}
      >
        <Button
          fontSize={'2xs'}
          fontWeight={displayLevels === 'M' ? '600' : '500'}
          p='2'
          color={displayLevels === 'M' ? '#8B5CF6' : fontColor}
          sx={{
            background: displayLevels === 'M' ? bg : 'transparent',
            border: '1px solid',
            borderColor: displayLevels === 'M' ? '#8B5CF6' : '#E2D9F3',
            borderRadius: '5px',
            '&:hover': {
              bg,
            },
          }}
          onClick={() => handleChange('M')}
          borderRadius={0}
        >
          M
        </Button>
      </ButtonGroup>
      <ButtonGroup
        isAttached
        variant='none'
        size={isMobile ? 'xs' : 'xs'}
        display='flex'
        isDisabled={isDisabled}
      >
        <Button
          p='2'
          fontSize={'2xs'}
          fontWeight={displayLevels === 'Q' ? '600' : '500'}
          color={displayLevels === 'Q' ? '#8B5CF6' : fontColor}
          sx={{
            background: displayLevels === 'Q' ? bg : 'transparent',
            border: '1px solid',
            borderColor: displayLevels === 'Q' ? '#8B5CF6' : '#E2D9F3',
            borderRadius: '5px',
            '&:hover': {
              bg,
            },
          }}
          onClick={() => handleChange('Q')}
          borderRadius={0}
        >
          Q
        </Button>
      </ButtonGroup>
      <ButtonGroup
        isAttached
        variant='none'
        size={isMobile ? 'xs' : 'xs'}
        display='flex'
        isDisabled={isDisabled}
      >
        <Button
          p='2'
          fontSize={'2xs'}
          fontWeight={displayLevels === 'Y' ? '600' : '500'}
          color={displayLevels === 'Y' ? '#8B5CF6' : fontColor}
          sx={{
            backgroundColor: displayLevels === 'Y' ? bg : 'transparent',
            border: '1px solid',
            borderColor: displayLevels === 'Y' ? '#8B5CF6' : '#E2D9F3',
            borderRadius: '5px',
            '&:hover': {
              bg,
            },
          }}
          onClick={() => handleChange('Y')}
          borderRadius={0}
        >
          Y
        </Button>
      </ButtonGroup>
    </Flex>
  );
};

export default RevampTabsFilter;
